import React, { useState } from 'react';
import { Form, Row, Modal, notification, Radio } from 'antd';
import { useTranslation } from 'react-i18next';
import { Loading } from '../index';
import { getZonesWithCurrentSlot, orderTransfer } from 'store/requests/order';
import { STATUS } from 'helpers/constants';
import DebounceSelect from 'components/DebounceSelect';
import { getStoreList } from 'store/requests/definitions';

const OrderTransfer = ({ onCloseHandler, orderNumber, onSuccessCalback }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [zones, setZones] = useState([]);
  const [isLoadingZones, setIsLoadingZones] = useState(false);
  const [radioValue, setRadioValue] = useState(false);
  const [form] = Form.useForm();

  const notificationToast = (type, message, description) => {
    notification[type]({
      message,
      description,
    });
  };

  const onFinish = async (values) => {
    setLoading(true);

    const payload = {
      orderNumber,
      storeId: values.storeId.value,
      zoneId: values.zoneId,
    };

    orderTransfer(payload)
      .then((data) => {
        setLoading(true);
        notificationToast(
          STATUS.SUCCESS,
          t('processCompleted'),
          t('orderTransferred'),
        );
        onSuccessCalback();
      })
      .catch((error) => {
        if (error?.errors) {
          let detailedErrorMessage = error.errors
            .map((err) => err.message)
            .join(', ');
          notificationToast(STATUS.ERROR, error.message, detailedErrorMessage);
          return
        }
        notificationToast(STATUS.ERROR, error.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const handleChangeStore = (selectedValue) => {
    setZones([]);
    setRadioValue(null);
    form.setFieldValue('zoneId', null);
    if (selectedValue?.value) {
      setIsLoadingZones(true);
      getZonesWithCurrentSlot(selectedValue.value)
        .then((res) => {
          if (res?.content.length === 1) {
            form.setFieldValue('zoneId', res.content[0]?.id);
            setRadioValue(res.content[0]?.id);
          }
          setZones(res?.content);
        })
        .catch((error) => {
          console.error('Error fetching zones:', error);
        })
        .finally(() => setIsLoadingZones(false));
    }
  };

  const getStoresByWords = (value) => {
    return getStoreList(
      `filter=(name=like='${value}' or code=like='${value}') and (ecomStatus=like="TEMPORARY_CLOSED" or ecomStatus=like="OPEN") and active==true&size=2000`,
    ).then((res) => {
      return (res?.content || []).map((store) => ({
        label: `${store.code} - ${store.name}`,
        value: store.id,
        key: store.id,
      }));
    });
  };

  return (
    <div style={{ position: 'relative' }}>
      {loading && (
        <div className="loadingDiv">
          <Loading />
        </div>
      )}
      <Modal
        centered
        open={true}
        maskClosable={false}
        onOk={() => form.submit()}
        okButtonProps={{ loading: loading, disabled: !radioValue }}
        onCancel={onCloseHandler}
        okText={t('transferOrder')}
        title={t('orderTransfer')}
        width={800}
      >
        <Row gutter={20}>
          <Form
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 24 }}
            name="basic"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            form={form}
            style={{ width: '100%' }}
          >
            <Form.Item
              label={t('targetStore')}
              labelAlign="left"
              name="storeId"
              labelWrap
              style={{ width: '100%' }}
            >
              {
                <DebounceSelect
                  mode="single"
                  showSearch
                  placeholder={t('enterAFewLettersForStoreSearch')}
                  fetchOptions={getStoresByWords}
                  style={{ width: '100%' }}
                  onChange={handleChangeStore}
                  allowClear
                />
              }
            </Form.Item>
            <Form.Item
              label={t('zone')}
              labelAlign="left"
              name="zoneId"
              labelWrap
              style={{ width: '100%' }}
              rules={[
                {
                  required: true,
                  message: t('alert.fillField'),
                },
              ]}
            >
              <Radio.Group
                style={{ width: '100%', maxHeight: '500px', overflowY: 'auto' }}
                onChange={(e) => setRadioValue(e.target.value)}
                value={radioValue}
              >
                {zones && zones.length > 0
                  ? zones.map((zone) => (
                      <React.Fragment key={zone?.id}>
                        <Radio value={zone?.id}>
                          {`${zone.code} - ${zone.name} (${zone?.currentSlot?.startTime || ''} - ${zone?.currentSlot?.endTime || ''})`}
                        </Radio>
                        <br />
                        <br />
                      </React.Fragment>
                    ))
                  : isLoadingZones && <Loading />}
              </Radio.Group>
            </Form.Item>
          </Form>
        </Row>
      </Modal>
    </div>
  );
};

export default OrderTransfer;
